import { ObjectFieldTemplateProps } from "@rjsf/utils";
import { formatSchemaName } from '../../utils/formatSchemaName';

export const ObjectFieldTemplate = (props: ObjectFieldTemplateProps) => {
  const entryNumber = props.title.match(/\d+$/);
  const titleString = entryNumber ? `Entry ${entryNumber[0]}` : formatSchemaName(props.title);
  const title = <h3>{titleString}</h3>;
  return (
    <div>
      {title}
      {props.description}
      {props.properties.map((element) => (
        <div className="property-wrapper">{element.content}</div>
      ))}
    </div>
  );
};
